import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { auth, db } from '../utils/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { collection, query, where, getDocs, updateDoc, addDoc } from 'firebase/firestore';
import { Container, Typography, Button, Alert, Box } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const Register = () => {
  const [searchParams] = useSearchParams();
  const module = searchParams.get('module');
  const token = searchParams.get('token');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [validToken, setValidToken] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      if (!module || !token) {
        setError('Invalid registration link.');
        return;
      }
      try {
        const q = query(collection(db, 'tokens'), where('module', '==', module), where('token', '==', token), where('used', '==', false));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          setValidToken(true);
        } else {
          setError('Invalid or used token.');
        }
      } catch (err) {
        setError('Token validation failed.');
      }
    };
    validateToken();
  }, [module, token]);

  const handleGoogleRegister = async () => {
    setError('');
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account'
    });
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      // Mark token as used
      const q = query(collection(db, 'tokens'), where('module', '==', module), where('token', '==', token));
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach(async (doc) => {
        await updateDoc(doc.ref, { used: true });
      });

      // Add user to module
      await addDoc(collection(db, `modules/${module}/users`), {
        uid: user.uid,
        name: user.displayName,
        email: user.email,
        registeredAt: new Date()
      });

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    }
  };

  if (!validToken && !error) return <Container><Typography>Loading...</Typography></Container>;

  if (success) return <Container><Alert severity="success">Registration successful! You can now access {module}.</Alert></Container>;

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>Register for {module}</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
        <Typography variant="body1">Sign in with Google to register. We'll only access your name and email.</Typography>
        <Button variant="contained" startIcon={<GoogleIcon />} onClick={handleGoogleRegister} sx={{ backgroundColor: '#4285F4', '&:hover': { backgroundColor: '#3367D6' } }}>
          Sign in with Google
        </Button>
      </Box>
    </Container>
  );
};

export default Register;